import { render, staticRenderFns } from "./COG_SettingsWindow.vue?vue&type=template&id=4f8b8cef&scoped=true"
import script from "./COG_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./COG_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b8cef",
  null
  
)

export default component.exports